import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface ThemeState {
  isDark: boolean
  toggleTheme: () => void
  setTheme: (isDark: boolean) => void
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      isDark: false,
      toggleTheme: () =>
        set((state) => {
          const newDark = !state.isDark
          document.documentElement.classList.toggle('dark', newDark)
          return { isDark: newDark }
        }),
      setTheme: (isDark: boolean) => {
        document.documentElement.classList.toggle('dark', isDark)
        set({ isDark })
      },
    }),
    { name: 'procoach-desktop-theme' }
  )
)

// Initialize theme on load
const stored = localStorage.getItem('procoach-desktop-theme')
if (stored) {
  try {
    const parsed = JSON.parse(stored)
    if (parsed?.state?.isDark) {
      document.documentElement.classList.add('dark')
    }
  } catch {}
}
